import React, { useState } from 'react';
import styles from './inviteCandidates.module.scss';
import { Col, Container, Form, Button, Badge, Row, Alert, Card } from 'react-bootstrap';
import { CustomAlertBox } from '../../../../shared/customAlertBox';
import { CustomButton } from '../../../../shared/customButton';
import * as yup from 'yup';
import { Formik } from 'formik';
import { inviteCandidates } from '../../../../../services/util/hiringpipeline/candidates';

const InviteCandidates = (props) => {
    const [isLoading, setStatus] = useState(false);
    const [disableBtn, setDisableBtn] = useState(false);
    const [emptyEmail, setEmptyEmail] = useState(false);
    const [duplicateEmail, setDuplicateEmail] = useState(false);
    let [state, setState] = useState({
        email: []
    });

    //yup validations
    const schema = yup.object({
        candidateEmail: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').email('Invalid email').required('Required')
    });

    function addItem(item) {
        setState(state => ({
            email: [...state.email, item]
        }));
    }

    function removeEmail(item) {
        let array = [state.email];
        if (item !== -1) {
            array[0].splice(item, 1);
            setState({
                email: array[0]
            })
            setDisableBtn(false);
        }
    }

    //on adding emails function
    const onSubmit = async (values, { resetForm }) => {
        let value = values.candidateEmail.toLowerCase();
        
        if (state.email.includes(value)) {
            setDuplicateEmail(true);
            resetForm({});
        } else {
            if (state.email.length >= 10) {
                setDisableBtn(true);
                resetForm({});
            } else {
                if (state.email.length === 9) {
                    addItem(value);
                    resetForm({});
                    setDisableBtn(true);
                } else {
                    addItem(value);
                    resetForm({});
                }
            }
        }
    }

    //on submitting Emails

    const submitEmails = async (values) => {
        if (values.email.length > 0) {
            setStatus(true)
            let respond = await inviteCandidates(values.email, props.pipelineID)
            if (respond.success) {
                setStatus(false)
                props.closeSideBar();
                props.getPipelineValues();
            } else {
                setStatus(false)
            }
        } else {
            setEmptyEmail(true)
        }

    }

    return (
        <div className={styles.sideBarContent}>
            <h5 className={styles.sidebarTopic}>Invite Candidates</h5>
            <Container>
                <Col className={styles.alertColumn}>
                    <CustomAlertBox
                        alertBodyText="You can invite any number of candidates. But only 10 candidate invites can submit at a time."
                        alertType="defaultAlert"
                    />
                </Col>
                <Col className={styles.innerContainer}>
                    <Formik
                        validationSchema={schema}
                        onSubmit={(values, resetForm) => onSubmit(values, resetForm)}
                        initialValues={{}}>

                        {({
                            errors,
                            setFieldValue,
                            handleSubmit,
                            submitCount,
                            values,
                        }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group className={styles.formText} controlId="multiEmail">
                                    <Form.Label
                                        className={styles.defaultLabel}>
                                        Candidate Email
                                    </Form.Label>
                                    <div className={styles.inputFormDiv}>
                                        <Form.Control
                                            className={styles.defaultTextBox}
                                            name="candidateEmail"
                                            type="email"
                                            id="adminPanel_hiringPipeline_viewPipeline_inviteCandidates_emailFieldId"
                                            value={values.candidateEmail || ''}
                                            onChange={(e) => { setFieldValue('candidateEmail', e.target.value); setDuplicateEmail(false)}}
                                            onFocus={() => setEmptyEmail(false)}
                                            isInvalid={submitCount > 0 && !!errors.candidateEmail}
                                            disabled={disableBtn}
                                        />
                                        <Button type="submit" variant="primary" className={styles.emailAddBtn} id="adminPanel_hiringPipeline_viewPipeline_inviteCandidates_addBtnId" disabled={disableBtn}>Add</Button>
                                    </div>
                                    {submitCount > 0 && errors.candidateEmail &&
                                        < p className={styles.errorMessage} id="adminPanel_hiringPipeline_viewPipeline_inviteCandidates_emailValidationMsgId">{errors.candidateEmail}</p>
                                    }
                                    {emptyEmail === true &&
                                        <p className={styles.errorMessage} id="adminPanel_hiringPipeline_viewPipeline_inviteCandidates_emailValidationMsgId">You must add at least one email address.</p>
                                    }
                                    {disableBtn === true &&
                                        <p className={styles.errorMessage} id="adminPanel_hiringPipeline_viewPipeline_inviteCandidates_emailValidationMsgId">You can submit maximum 10 emails at a time.</p>
                                    }
                                    {duplicateEmail === true &&
                                        <p className={styles.errorMessage} id="adminPanel_hiringPipeline_viewPipeline_inviteCandidates_emailValidationMsgId">Duplicate emails.</p>
                                    }
                                </Form.Group>
                            </Form>
                        )}
                    </Formik>
                </Col>
                <Col>
                    {state.email.length !== 0 &&
                        <Card className={styles.resultBox}>
                            <Row className="ml-0 mr-0">
                                {
                                    state.email.map((item, i) => (
                                        (
                                            <div className={styles.emailContainer}>
                                            <div className={styles.emailbadgeDiv} key={i}>
                                                <Badge text='info' bg="light"  className={styles.emailbadge}>{item}&nbsp;&nbsp;
                                                    <span onClick={() => removeEmail(i)}>
                                                        <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M10.5 3.5L3.5 10.5" stroke="#24859A" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M3.5 3.5L10.5 10.5" stroke="#24859A" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                </Badge>
                                            </div>
                                            </div>
                                        )
                                    ))
                                }
                            </Row>
                        </Card>
                    }
                </Col>
                <Col className="mt-3">

                    <CustomButton
                        type="primaryBtn"
                        buttonType="button"
                        label="Submit"
                        id="adminPanel_hiringPipeline_viewPipeline_inviteCandidates_SubmitBtnId"
                        disabled={isLoading === true ? true : false}
                        backicon=
                        {isLoading === true ?
                            <i className="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
                            : ''
                        }
                        handleClick={() => submitEmails(state)}

                    />
                </Col>
                <Col>
                    <p className={styles.BottomMessage}><span className={styles.BottomNotice}>Note:</span>Please, enter correct email addresses. Once you submit the emails you will not be able to change them.</p>
                </Col>
            </Container>
        </div>
    )
}

export default InviteCandidates;